module.exports = __webpack_public_path__ + "img/graphics-kvadmin.3081fb03.jpg";